import { render, staticRenderFns } from "./clientLogin.vue?vue&type=template&id=3fa47810"
import script from "./clientLogin.vue?vue&type=script&lang=js"
export * from "./clientLogin.vue?vue&type=script&lang=js"
import style0 from "./clientLogin.vue?vue&type=style&index=0&id=3fa47810&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports